module.exports = __webpack_public_path__ + "static/media/HotSchedulesLogo.f8759c12.png";